<template>
  <div>
    <div class="modal is-active">
      <div class="modal-background" @click="!autoSelectNext && $emit('closeModal')"></div>
      <div class="modal-content">
        <div class="rdv-header">
          <div class="is-size-4 is-size-5-mobile has-font-weight-bold">
            {{ getSelectedPrestationsString }}
          </div>
          <div v-if="agenda" class="is-size-5 is-size-6-mobile pb-1">
            {{ agenda.internet_name || agenda.name }}
          </div>
        </div>
        <div id="rdv_body" class="rdv-info-body">
            <div class="container">
                <div class="info">
                    <p class="has-text-centered" v-if="start_date"></p>
                    <p v-if="config.display_duration">
                        <span class="icon is-large">
                        <i class="fa fa-clock fa-lg"></i>
                        </span>
                        {{ duration }}
                    </p>
                    <p v-if="config.display_price">
                        <span class="icon is-large">
                        <i class="fa fa-euro-sign fa-lg"></i>
                        </span>
                        {{ price }}
                    </p>
                    <div class="columns mb-0 is-mobile" v-if="location">
                        <div
                        class="column is-narrow is-flex is-flex-direction-column is-justify-content-center pr-0 pb-0"
                        >
                        <span class="icon is-large pb-0"
                            ><i class="fa fa-map-marker-alt fa-lg"></i
                        ></span>
                        </div>
                        <div class="column px-0 pb-0">
                        <p>{{ location.name }}</p>
                        <p>{{ renderLocationAddress(location) }}</p>
                        </div>
                    </div>

                    <p v-if="start_date">
                        <span class="icon is-large">
                        <i class="fa fa-clock fa-lg"></i>
                        </span>
                        {{ start_date }}
                    </p>
                </div>
                <div v-if="config['confirm_web_rdv'] == 1 && rdv_requested" class="confirm-message">Votre demande de rdv sera envoyée, elle sera en attente de validation par votre prestataire. Une fois le rdv confirmé, vous receverez un email de confirmation de votre rdv.</div>
            </div>


            <!-- Champs supplémentaires du rdv -->
            <div v-if="!this.rdv_data.rdv_id && this.showExtraFields" id="rdv_extra_fields_bloc" class="" style="grid-template-columns: auto auto;">
                <!-- <div> -->
                    <div class="is-size-5 is-size-6-mobile" style="text-align: center;">Infos complémentaires du rdv</div>
                    <div id="" class=" " style="display: grid; grid-template-columns: auto auto; padding: 1rem; padding-top: 0;">
                        <div class="field" v-for="(field, index) in this.prestations_fields" :key="index">
                            <label class="label">{{field.name}} <span v-if="field.required">*</span> </label>
                            <div class="control">
                                <input
                                    @input="formatPhone"
                                    class="input is-rounded"
                                    type="tel"
                                    maxlength="14"
                                    :placeholder="field.description??''"
                                    v-if="'telephone' === field.data_type"
                                    :required="!!field.required"
                                    :id="`rdv-field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                    :value="get_extfield_value(field)"
                                >
                                <input
                                    class="input is-rounded"
                                    :type="field.data_type"
                                    :placeholder="field.description??''"
                                    v-else-if="['text', 'email', 'date', 'number'].includes(field.data_type)"
                                    :required="!!field.required"
                                    :id="`rdv-field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                    :value="get_extfield_value(field)"
                                >
                                <textarea
                                    v-else-if="field.data_type === 'textarea'"
                                    name=""
                                    class="textarea is-rounded"
                                    :required="!!field.required"
                                    :id="`rdv-field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                    :placeholder="field.description??''"
                                    :value="get_extfield_value(field)"
                                ></textarea>
                                <div
                                    class="select is-rounded is-flex-grow-1 is-flex"
                                    v-if="field.data_type === 'select'"
                                >
                                    <select name="" :id="`rdv-field-${field.internal_col_name}`" :required="!!field.required" class="is-flex-grow-1" :field_name="field.internal_col_name" :value="get_extfield_value(field)">
                                        <option value=""></option>
                                        <option v-for="(option, index) in field.data_values.split(',')" :key="index" :value="option" :selected="field.default_value == option">{{option}}</option>
                                    </select>
                                </div>
                                <div v-else-if="field.data_type === 'checkbox'" :id="`rdv-field-${field.internal_col_name}`">
                                    <div v-for="(option, index) in field.options" :key="index">
                                        <label :for="`option-${field.efs_is}-${option.value}`" class="checkbox" >
                                            <input
                                                type="checkbox"
                                                :name="field.internal_col_name"
                                                :id="`option-${field.efs_is}-${option.value}`"
                                                :value="option.value"
                                                :field_name="field.internal_col_name"
                                            >
                                            {{option.label}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
            </div>

            <!-- Champs supplémentaires pour participant -->
            <div v-if="!this.rdv_data.rdv_id && edit_participants" id="participants_bloc" class="" style="display: grid; grid-template-columns: auto auto; margin-top: 1.5rem;">
                <div>
                    <div class="is-size-6 is-size-6-mobile" style="text-align: center; font-weight: bold;">Saisir les infos des personnes qui vous accompagneront.</div>
                    <div id="" class=" " style="display: grid; grid-template-columns: auto auto; padding: 1rem; padding-top: 0;">
                        <div class="field" v-for="(field, index) in participants_fields" :key="index">
                            <label class="label">{{field.name}} <span v-if="field.required">*</span> </label>
                            <div class="control">
                                <input
                                    @input="formatPhone"
                                    class="input is-rounded"
                                    type="tel"
                                    maxlength="14"
                                    :placeholder="field.description??''"
                                    v-if="'telephone' === field.data_type"
                                    :required="!!field.required"
                                    :id="`field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                >
                                <input
                                    class="input is-rounded"
                                    :type="field.data_type"
                                    :placeholder="field.description??''"
                                    v-else-if="['text', 'email', 'date', 'number'].includes(field.data_type)"
                                    :required="!!field.required"
                                    :id="`field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                >
                                <textarea
                                    v-else-if="field.data_type === 'textarea'"
                                    name=""
                                    class="textarea is-rounded"
                                    :required="!!field.required"
                                    :id="`field-${field.internal_col_name}`"
                                    :field_name="field.internal_col_name"
                                    :placeholder="field.description??''"
                                ></textarea>
                                <div
                                    class="select is-rounded is-flex-grow-1 is-flex"
                                    v-if="field.data_type === 'select'"
                                >
                                    <select name="" :id="`field-${field.internal_col_name}`" :required="!!field.required" class="is-flex-grow-1" :field_name="field.internal_col_name">
                                        <option value=""></option>
                                        <option v-for="(option, index) in field.data_values.split(',')" :key="index" :value="option" :selected="field.default_value == option">{{option}}</option>
                                    </select>
                                </div>
                                <div v-else-if="field.data_type === 'checkbox'" :id="`field-${field.internal_col_name}`">
                                    <div v-for="(option, index) in field.options" :key="index">
                                        <label :for="`option-${field.efs_is}-${option.value}`" class="checkbox" >
                                            <input
                                                type="checkbox"
                                                :name="field.internal_col_name"
                                                :id="`option-${field.efs_is}-${option.value}`"
                                                :value="option.value"
                                                :field_name="field.internal_col_name"
                                            >
                                            {{option.label}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="btn-list" @click="addParticipant">+</button>
                <div>
                    <div class="is-size-5 is-size-6-mobile" style="text-align: center;">Liste des participants</div>
                    <div id="participant-list">
                        <div v-for="(participant, index) in current_participants" :id="'item-'+index" @click="set_selected_participant(index)" :class="'row '+(selectedParticipant == index ? 'selected-item' : '')" style="margin-bottom: 0.25rem;">
                            <span v-for="column in this.participants_fields">{{ participant[column['internal_col_name']] }}&nbsp;</span>
                        </div>
                    </div>
                </div>

                <button class="btn-list" @click="removeParticipant(selectedParticipant)">-</button>
            </div>

            <!-- Input document -->
             <div v-if="!this.rdv_data.rdv_id && (this.prestations[0].allow_attachment == 1 || this.prestations[0].force_attachment)">
                <div class="control" style="padding: 1rem;">
                    <label class="label">{{this.prestations[0].label_attachment ?? 'Joindre un fichier'}}<span v-if="this.prestations[0].force_attachment">*</span> </label>
                    <input type="file" id="attachment" @change="setAttachment" >
                    <div id="attachment_size_msg" style="font-size: 12px">La taille du fichier ne doit pas dépasser 2Mo</div>
                </div>
             </div>

             <p class="help is-danger is-size-6" style="text-align: center;"> {{error_message}} </p>

            <div class="buttons is-flex is-justify-content-flex-end pr-4" v-if="start_date && !this.paymentEnabled || this.paymentEnabled && this.is_paid">
                <button id="btn-confirm" v-if="!(config['confirm_web_rdv'] == 1 && rdv_requested)" :class="is_loading ? 'button is-info is-rounded is-loading' : 'button is-info is-rounded'" @click="createRdv">
                    {{config['confirm_web_rdv'] == 1 ? "Demande de rendez-vous" : "Confirmer le rendez-vous"}}
                </button>
                <button v-if="config['confirm_web_rdv'] == 1 && rdv_requested" v-on:click="this.$inertia.get('/')" class="button is-info is-rounded">Ok, j'ai compris</button>
            </div>
            <div v-if="this.paymentEnabled && !this.is_paid" class="columns buttons mx-2">
                <div class="column">
                    <button v-if="this.stripeEnabled" :class=" is_loading ? 'button is-link is-loading' : 'button is-link'" @click="stripePayment" style="width: 100%;">
                        Payer avec Stripe
                    </button>
                    <button v-if="this.systempayEnabled" :class=" is_loading ? 'button is-link is-loading' : 'button is-link'" @click="systempayPayment" style="width: 100%; background-color: #01b0cd;">
                        Payer via Systempay
                    </button>
                    <button v-if="this.paymentEnabled && !force_payment" :class=" is_loading ? 'button is-info is-loading' : 'button is-info'" @click="createRdv" style="width: 100%;">
                        Payer sur place
                    </button>
                </div>
                <div class="column" v-if="this.paypalEnabled" ref="paypal" ></div>
            </div>
        </div>
      </div>
      <button v-if="!autoSelectNext"
        class="modal-close is-large"
        aria-label="close"
        @click="$emit('closeModal')"
      ></button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "bulma-toast";
import { createPaypalBnt, stripeHandlePayment, handlePayment } from "../../../payment";

export default {
  props: [
    "rdv_data",
    "client_infos",
    "withAuth",
    "autoSelectNext",
    "price",
    "duration",
    'group_size',
    "prestations",
    "prestations_ids",
    "location",
    "agenda",
    "start_date",
    "config",
    'fo_config',
    'attendees'
  ],
  data() {
    return {
      prestations_fields: [],
      participants_fields: [],
      is_loading: false,
      rdv_requested: false,
      participants: [],
      selectedParticipant: null,
      error_message: null,
      attachment: null
    };
  },
  mounted() {
    if (this.paypalEnabled) {
      const paypalBtn = this.$refs.paypal;
      console.log('ConfirmationPopup paypalBtn',paypalBtn);
      createPaypalBnt(
        ()=>this.$props.rdv_data,
        this.withAuth,
        ()=>this.$inertia.get("/"),
        ()=>{},
        () => {
            // Insertion des valeurs des extrafields du rdv si existent
            if(this.showExtraFields){
                let result = this.set_extra_fields_values_to_rdv_data();
                // Arrêter la création de rdv si champs non valid
                if(!result){
                    return false;
                }
            }
            return true;
        }
       ).render(paypalBtn);
    }
    this.get_prestations_fields();
    if(this.rdv_data.rdv_id){
        if(this.attendees) this.participants = this.attendees;
    }
    console.log('rdv_data', this.rdv_data);
    
  },
  computed: {
    paymentEnabled: function(){
      return this.config.enable_paiement != 0 &&  0 < +this.price.replace(/[^0-9.]/,'');
    },
    paypalEnabled: function() {
      return this.paymentEnabled && window.paypal;
    },
    stripeEnabled: function(){
      return this.paymentEnabled && window.stripe;
    },
    systempayEnabled: function() {
        return this.paymentEnabled;
    },
    current_participants: function(){
        return this.participants;
    },
    getSelectedPrestationsString () {
            return this.prestations.map(prestation => prestation.fo_name || prestation.bo_name).join(', ')
    },
    getSelectedPrestationsIds(){
        return this.prestations.map(prestation => prestation.prestation_id);
    },
    edit_participants() {
        if(this.group_size < 2 || this.participants_fields.length < 1){
            return false;
        }

        for (let i = 0; i < this.prestations.length; i++) {
            if (this.prestations[i].is_group == 1 && this.prestations[i].allow_subgroup == 1
                && (this.prestations[i].edit_participants == 1 || this.prestations[i].forced_to_edit_participants == 1)) {
                return true;
            }
        }
        return false;
    },
    subgroup_out_of_range(){
        if((this.group_size - 1) == this.participants.length){
            return false
        }
        return true;
    },
    showExtraFields() {
        return this.prestations[0].is_group == 0 && this.prestations_fields.length > 0;
    },
    redirected(){
      return this.fo_config && (this.fo_config['redirected'] == 1);
    },
    redirect_params(){
      if(!this.redirected){
        return '';
      }
      let url = window.location.href;
      // let params = url.substring(url.lastIndexOf('/')+1).replace('times','');
      let params = url.split('?',2)[1];
      return '?'+params+'&redirected=1';
    },
    is_updating() {
        return this.rdv_data.rdv_id ? true : false;
    },
    is_paid() {
        return this.is_updating && this.rdv_data.paid;
    },
    force_payment() {
        for (let i = 0; i < this.prestations.length; i++) {
            if (this.prestations[i].force_payment == 1) {
                return true;
            }
        }
        return false;
    }
  },

  methods: {
    stripePayment(){
        if(this.edit_participants && this.prestations[0].forced_to_edit_participants == 1 && this.subgroup_out_of_range){
            this.error_message = "Le nombre de participants doit être de "+this.group_size;
            if(this.prestations[0].allow_use_attach_for_attendees == 1){
                if(!this.attachment) {
                    this.error_message += " ou joindre un fichier à la place";
                    return false;
                }
            }else{
                return false;
            }
        }
        if(!this.validateAttachment()){
            this.error_message = "Une pièce jointe est requise";
            return false;
        }
        // Insertion des valeurs des extrafields du rdv si existent
        if(this.showExtraFields){
            let result = this.set_extra_fields_values_to_rdv_data();
            // Arrêter la création de rdv si champs non valid
            if(!result){
                return false;
            }
        }
        // return false;
        this.error_message = null;
        handlePayment(data,'stripe',this.withAuth).then((response_data)=>{
            this.show = false;
            document.location = response_data.url;
        })
    },
    systempayPayment(){
        if(this.edit_participants && this.prestations[0].forced_to_edit_participants == 1 && this.subgroup_out_of_range){
            this.error_message = "Le nombre de participants doit être de "+this.group_size;
            if(this.prestations[0].allow_use_attach_for_attendees == 1){
                if(!this.attachment) {
                    this.error_message += " ou joindre un fichier à la place";
                    return false;
                }
            }else{
                return false;
            }
        }
        if(!this.validateAttachment()){
            this.error_message = "Une pièce jointe est requise";
            return false;
        }
        // Insertion des valeurs des extrafields du rdv si existent
        if(this.showExtraFields){
            let result = this.set_extra_fields_values_to_rdv_data();
            // Arrêter la création de rdv si champs non valid
            if(!result){
                return false;
            }
        }
        // return false;
        this.error_message = null;
        handlePayment(this.$props.rdv_data,'systempay').then((data) => {
            // Préparation du formulaire de paiement
            let form = document.createElement("form");
            form.id = "systempay-form";
            form.action = data.redirec_url;
            form.method = "post";
            Object.keys(data).forEach(function (key) {
              var input = document.createElement("input");
              input.type = "text";
              input.name = key;
              input.value = data[key];
              form.appendChild(input);
            });
            document.body.appendChild(form);
            // Rédirection vers l'interface de paiement
            form.submit();
            document.body.removeChild(form);
        });
    },
    redirect(id_container, form) {
        // let form_el = document.createElement('div');
        // form_el.insert
        console.log('in redirect');
        
        let container = document.getElementById(id_container);
        console.log('container',container,form);
        
        container.insertAdjacentHTML('afterbegin',form);
        let redirect_form = document.getElementById('rdv_redirect_form');
        redirect_form.submit();

        console.log('redirect element',redirect_form);
        
    },
    createRdv() {
        if(this.edit_participants && this.prestations[0].forced_to_edit_participants == 1 && this.subgroup_out_of_range){
            this.error_message = "Le nombre de participants doit être de "+(this.group_size - 1);
            if(this.prestations[0].allow_use_attach_for_attendees == 1){
                if(!this.attachment) {
                    this.error_message += " ou joindre un fichier à la place";
                    return false;
                }
            }else{
                return false;
            }
        }
        // Ne pas vérifier la validation de pièce jointe dans le cas de la modification
        if(!this.rdv_data.rdv_id && !this.validateAttachment()){
            this.error_message = "Une pièce jointe est requise";
            return false;
        }
        // Insertion des valeurs des extrafields du rdv si existent
        if(!this.rdv_data.rdv_id && this.showExtraFields){
            let result = this.set_extra_fields_values_to_rdv_data();
            // Arrêter la création de rdv si champs non valid
            if(!result){
                return false;
            }
        }
        this.error_message = null;
        this.is_loading = true;
        
        // Set client 
        this.rdv_data.client = this.client_infos;

        axios(this.get_axios_params())
            .then((response) => {
                this.is_loading = false;

                // Envoie de la pièce jointe
                if(this.attachment && response.data.rdv_id && response.data.client_id){
                    let form_data = new FormData();
                    form_data.append('rdv_id',response.data.rdv_id);
                    form_data.append('client_id',response.data.client_id);
                    form_data.append('file_extension',this.attachment.name.split('.').pop());
                    form_data.append('attachment',this.attachment);
                    if(response.data?.confirm_message) form_data.append('confirm_message',response.data?.confirm_message);
                    axios
                        .post('rdv/attach', form_data, {headers: {'Content-Type': 'multipart/form-data'}})
                        .then((attach_response) => {})
                        .catch((error) => {
                            toast({
                                message: error || "La pièce jointe n'a pas pu être chargée !",
                                type: "is-danger",
                                duration: 5000,
                                pauseOnHover: true,
                            });
                        })
                }
                if(this.config['confirm_web_rdv'] != 1){
                    if(this.redirected){
                        if(this.fo_config['redirect_url']){
                            let data = {...this.fo_config['redirect_params'], ...response.data};
                            data['rdv_id'] = response.data?.rdv_id;
                            data['reservation_statut'] = 'VALIDER';
                            console.log('data',data,response.data);
                            
                            axios
                                .post('form',data)
                                .then((response) => {
                                    this.redirect('rdv_body',response.data);
                                })
                                .catch((error) => {});
                            // window.location.replace(atob(this.fo_config['redirect_url']))
                        }else{
                            this.$inertia.get("/");
                        }
                    }else{
                        this.$inertia.get(this.withAuth ? '/account'+this.redirect_params : '/');
                    }
                }
                else this.rdv_requested = true;
            })
            .catch((err) => {
            toast({
                message:
                err?.response?.data?.message ||
                "Le rendez-vous n'a pas pu être créé.",
                type: "is-danger",
                duration: 5000,
                pauseOnHover: true,
            });
            this.is_loading = false;
            });
    },
    renderLocationAddress(location) {
      if (!location.address) return "";
      let localisation_regex =
        /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/;
      return location.address
        .split(" ")
        .filter((elt) => !elt.match(localisation_regex))
        .join(" ");
    },
    get_prestations_fields(){
        axios.get('/prestations/extrafields',{params: {ids: this.getSelectedPrestationsIds, has_presta_group: this.has_presta_group()}}).then(response => {
            this.prestations_fields = response.data['presta_ext_fields'].sort((a, b) => a.position - b.position);
            this.participants_fields = response.data['attendee_presta_ext_fields'].sort((a, b) => a.position - b.position);
        })
    },
    addParticipant(){
        let participant = {};
        let data = this.validateDynamiqueFields('participants_bloc', this.participants_fields);

        if(data){
            this.error_message = null;
        }else{
            return false;
        }

        for (const field of this.participants_fields) {
            participant[field.internal_col_name] = document.getElementById('field-'+field.internal_col_name).value;
            document.getElementById('field-'+field.internal_col_name).value = null;
        }
        this.participants.push(participant);
        this.add_participants_to_rdv_data();
    },
    removeParticipant(index){
        this.participants.splice(index, 1);
        this.add_participants_to_rdv_data();
    },
    set_selected_participant(index){
        if(this.selectedParticipant == index){
            this.selectedParticipant = null;
        }else{
            this.selectedParticipant = index;
        }
    },
    add_participants_to_rdv_data(){
        this.rdv_data['participants'] = this.participants;
    },
    set_extra_fields_values_to_rdv_data(){
        let data = this.validateDynamiqueFields('rdv_extra_fields_bloc', this.prestations_fields);
        if(data){
            this.error_message = null;
        }else{
            return false;
        }
        for (const field of this.prestations_fields) {
            this.rdv_data[field.internal_col_name] = document.getElementById('rdv-field-'+field.internal_col_name).value;
        }
        return true
    },
    validateDynamiqueFields(bloc_id, presta_fields){
        // if (this.is_loading) return false

        let fields = document.querySelectorAll(`#${bloc_id} [field_name]`);

        let data = {}
        for (let field of fields) {
            if (field.getAttribute('type') === 'checkbox' && !field.checked) continue;
            let field_name = field.getAttribute('field_name');
            let elt = data[field_name]||[];
            if (field.value) elt.push(field.value);
            data[field_name] = elt;
        }
        for (let key in data) {
            let field = presta_fields.find(field => field.internal_col_name === key);
            if (field.data_type !== "checkbox") data[key] = data[key].toString();
            if (field.required && (!data[key] || (data[key]+"").trim() == "")) {
                let field_name = field.name ? field.name?.toLowerCase() : null;
                this.error_message =
                    field_name ?
                    `Le champ "${field_name}" est obligatoire.` :
                    "Merci de renseigner tous les champs obligatoires."
                return false
            }
            if(field.data_type === 'date'){
                let result = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data[key]);
                if (result){
                    data[key] = `${result[3]}/${result[2]}/${result[1]}`
                }else if(/^\d{2}\/\d{2}\/\d{4}$/.test(data[key])){
                }else{
                    let field_name = field.name.toLowerCase()
                    this.error_message =  `Le champ "${field_name}" doit être une date valide.`
                    return false
                }
            }
        }
        return data;
    },
    setAttachment($event) {
        const target = $event.target;
        let size = (target.files[0].size/1024)/1024;
        if (target && target.files && size <= 2) {
            this.attachment = target.files[0];
            document.querySelector('#attachment_size_msg').style.color = '#6c6387';

            document.querySelector('#attachment').style.color = 'inherit';
            document.querySelector('#file_label').remove();
        }else{
            document.querySelector('#attachment_size_msg').style.color = 'red';
            document.querySelector('#attachment').value = null;
        }
    },
    validateAttachment(){
        if(this.prestations[0].force_attachment == 1 ){
            return this.attachment ? true : false;
        }
        return true;
    },
    has_presta_group(){
        return this.prestations[0].is_group;
    },
    get_axios_params(){
        return this.rdv_data?.rdv_id != null ? {
                    method: 'PUT',
                    url:  "/rdv/"+this.rdv_data?.rdv_id,
                    data: this.rdv_data
                } : {
                    method: 'POST',
                    url:  window.location.origin+(this.withAuth ? "/rdv/add_rdv" : "/rdv/without_auth"),
                    data: this.rdv_data
                };
    },
    get_extfield_value(field){
        // console.log(field.data_type,this.rdv_data[field.internal_col_name],this.rdv_data);
        return this.rdv_data ? this.rdv_data[field.internal_col_name] : null;
    },
    getGroupSizeFromRdv(rdv){
        if(!rdv.prestation || rdv.prestation.is_group == 0 || !rdv.participants || rdv.participants.length < 1){
            return 1;
        }
        
        for (const participant of rdv.participants) {
            if (participant.client_id == this.user.client_id) {
                let attendees = JSON.parse(participant.attendees ?? '[]');
                return attendees.length + 1;
            }
        }

        return 1;
    }
  },
};
</script>
<style scoped>
.rdv-header {
    background-color: var(--card-header-bg-color);
    color: var(--card-header-text-color);
    border-radius: 20px;
    text-align: center;
    width: 60%;
    margin: auto;
    position: relative;
    top: 31px;
    padding: 2px 5px;
}
.rdv-info-body {
  background-color: #fff;
  padding-bottom: 15px;
  padding-top: 40px;
  border-radius: 20px;
  overflow: hidden;
}

.rdv-info-body .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.rdv-info-body .container .confirm-message {
    font-size: 14px;
    color: #271C49;
    padding: 2px;
    margin: 2px;
    font-weight: bolder;
    height: max-content;
    border: 2px #271C49 outset;
    border-radius: 12px;
}

#btn-confirm {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

#btn-confirm:hover {
    background-color: var(--btn-primary-bg-color-hover);
    color: var(--btn-primary-text-color);
}

.field{
    padding: 0.25rem;
}

.field input, .field textarea, .field label, .field select  {
    font-size: 0.75rem;
    min-width: unset;
    min-height: unset;
}

.select:not(.is-multiple):not(.is-loading)::after {
    top: 40%;
}

.btn-list {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    font-size: 3rem;
    font-weight: 900;
    background-color: #271C49;
    color: white;
    border-radius: 0.5rem;
}

.selected-item {
    background-color: #271C49;
    color: white;
}

#participant-list {
    text-align: center;
    padding: 1rem;
    margin: 0rem 2rem 2rem 2rem;
    border-radius: 2rem;
    border: 1px solid #b5b5b5;
}
</style>
